enum ACCOUNT_OPENING_DOCUMENT_STATUS {
  NONE = 0,
  AUTHORIZATION_PENDING = 1,
  AUTHORIZED = 2,
  REJECTED = 3,
}

export enum ACCOUNT_OPENING_REQUEST_STATUS {
  NONE = 0,
  PENDING_SUBMISSION_FROM_CLIENT = 1,
  SUBMITTED_BY_CLIENT = 2,
  QUERY_BY_SYSTEM = 3,
  READY_FOR_ESIGN = 4, // KRD++ 08102021
  ESIGN_COMPLETED = 5,
  QUERY_FROM_ACCOUNT_OPENING_TEAM = 6,
  AUTHORIZED_AND_ACCOUNT_OPENING_UNDER_PROGRESS = 7, // TKM++ 31032021
  ACCOUNT_OPENED = 8, // TKM++ 31032021
  DISCARDED = 9,
}
export enum ACCOUNT_OPENING_DOCUMENT_PARSE_STATUS {
  NONE = 0,
  PARSING_PENDING = 1,
  PARSING_FAILED = 2,
  VERIFIED = 3,
  VERIFICATION_FAILED = 4,
  NOT_APPLICABLE = 5,
  WARNING = 6,
}
export enum RW_PROCESS_BASIC_STATUS {
  NONE = 0,
  PENDING = 1,
  SUCCESS = 2,
  FAIL = 3,
  ERROR = 4,
  WARNING = 5,
  NOT_APPLICABLE = 9,
}

export enum BANK_ACCOUNT_TYPE {
  NONE = 0,
  SAVINGS_AC = 1,
  CURRENT_AC = 2,
  CASH_CREDIT_AC = 3,
  NRE_AC = 4,
  NRO_AC = 5,
  OTHER_AC = 99,
}

export enum PROOF_TYPE {
  NONE = 0,
  PASSPORT = 1,
  DRIVING_LICENSE = 2,
  VOTER_IDENTITY_CARD = 3,
  PAN = 4,
  AADHAAR = 5,
}

export enum ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION {
  NONE = 0,
  SPOUSE = 1,
  SON = 2,
  DAUGHTER = 3,
  FATHER = 4,
  MOTHER = 5,
  BROTHER = 6,
  SISTER = 7,
  GRAND_SON = 8,
  GRAND_DAUGHTER = 9,
  GRAND_FATHER = 10,
  GRAND_MOTHER = 11,
  OTHER = 99,
}

export enum ACCOUNT_OPENING_REQUEST_DATA_SOURCE {
  NONE = 0,
  AOR = 1, // Account Opening Request
  AOPR = 2, // Account Opening Prefilled Request
  PROCESSED_IMAGE = 3, // DPR++ 16122021, e.g. Bank details from cheque image processing.
}

export enum ACCOUNT_OPENING_DOCUMENT_TYPE {
  NONE = 0,

  PAN = 1,
  AADHAR = 2,
  CHEQUE_LEAF = 3,
  LIVE_PHOTO = 4,
  CLIENT_SIGNATURE = 5,
  BANK_STATEMENT = 6,
  DIGILOCKER_AADHAR_PHOTO = 7, // System will auto capture photo from e-Aadhar
  ESIGNER_AADHAR_PHOTO = 8, // KRD++ 23112021
  DP_CLIENT_MASTER = 9, // BW DP_CLIENT_MASTER = 256, // MMT++ 02122022

  SIGNED_AOF = 11, // DJT++ 15112021
  SIGNED_AOF_AUDIT_TRAIL = 12, // ADJ++ 06122021
  SIGNED_POA = 13, // DJT++ 15112021
  DEPOSITORY_BO_SETUP_RESPONSE_FILE = 14, // DJT++ 15112021

  UNKNOWN = 99,
}

export enum KRA_KYC_STATUS {
  NOT_CHECKED_WITH_MULTIPLE_KRA = 88,
  NOT_CHECKED_WITH_RESPECTIVE_KRA = 0,
}

class Enums {
  static SOME = {
    A: "A",
  };

  static SEGMENT_INTERNAL_CODE_BW = {
    EQUITY: 1,
    DERIVATIVE: 2,
    CURRENCY: 4,
    COMMODITY: 8,
    SLB: 32,
  };

  static ACCOUNT_OPENING_PRODUCT_BW = {
    EQUITY: 1,
    TRADING: 2,
    DEMAT: 4,
  };

  static PLMA_QUESTION = {
    GENDER: 1,
    MARITAL_STATUS: 2,
    INCOME_RANG_PER_ANNUM: 3,
    OCCUPATION: 4,
    PLEASE_TICK_IF_APPLICABLE: 5,
    INVESTMENT_TRADING_EXPERIENCE: 6,
  };

  static KYC_MODE = {
    NONE: 0,
    CVL_KRA: 1,
    DIGILOCKER: 2,
  };
  static ACCOUNT_OPENING_DOCUMENT_TYPE = ACCOUNT_OPENING_DOCUMENT_TYPE;
  static BANK_ACCOUNT_TYPE = BANK_ACCOUNT_TYPE;
  static ACCOUNT_OPENING_REQUEST_STATUS = ACCOUNT_OPENING_REQUEST_STATUS;
  static ACCOUNT_OPENING_DOCUMENT_PARSE_STATUS =
    ACCOUNT_OPENING_DOCUMENT_PARSE_STATUS;
  static RW_PROCESS_BASIC_STATUS = RW_PROCESS_BASIC_STATUS;
  static ACCOUNT_OPENING_REQUEST_DATA_SOURCE =
    ACCOUNT_OPENING_REQUEST_DATA_SOURCE;
  static ACCOUNT_OPENING_DOCUMENT_STATUS = ACCOUNT_OPENING_DOCUMENT_STATUS;
  static KRA_KYC_STATUS = KRA_KYC_STATUS;

  static AOR_EMAIL_MOBILE_STATUS_CODE = {
    PENDING: 1,
    COMPLETED: 2,
    REJECTED: 3,
    NOT_APPLICABLE: 9,
  };
  static GENDER = {
    MALE: 1,
    FEMALE: 2,
    OTHER: 3,
  };
}

export default Enums;

export const lstIDProof = [
  { label: "Passport", value: PROOF_TYPE.PASSPORT },
  { label: "Driving Licence", value: PROOF_TYPE.DRIVING_LICENSE },
  { label: "Voter Id Card", value: PROOF_TYPE.VOTER_IDENTITY_CARD },
  { label: "Pan", value: PROOF_TYPE.PAN },
  { label: "Aadhaar", value: PROOF_TYPE.AADHAAR },
  { label: "None", value: PROOF_TYPE.NONE },
];

export const lstNomineeRelation = [
  { label: "Spouse", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.SPOUSE },
  { label: "Son", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.SON },
  {
    label: "Daughter",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.DAUGHTER,
  },
  { label: "Father", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.FATHER },
  { label: "Mother", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.MOTHER },
  { label: "Brother", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.BROTHER },
  { label: "Sister", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.SISTER },
  {
    label: "Grandson",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_SON,
  },
  {
    label: "Granddaughter",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_DAUGHTER,
  },
  {
    label: "Grandfather",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_FATHER,
  },
  {
    label: "Grandmother",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_MOTHER,
  },
  { label: "Other", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.OTHER },
];

export const lstGradientRelation = [
  { label: "Father", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.FATHER },
  { label: "Mother", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.MOTHER },
  { label: "Brother", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.BROTHER },
  { label: "Sister", value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.SISTER },
  {
    label: "Grandfather",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_FATHER,
  },
  {
    label: "Grandmother",
    value: ACCOUNT_OPENING_SYSTEM_NOMINEE_RELATION.GRAND_MOTHER,
  },
];

export const lstNameTitle = [
  { label: "Mr.", value: "Mr." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Ms.", value: "Ms." },
  // { label: "Messrs.", value: "Messrs." },
];

export enum FAMILY_DECLARATION_LEGAL_RELATION {
  NONE = 0,
  SELF = 1,
  SPOUSE = 2,
  DEPENDENT_CHILD = 3,
  DEPENDENT_PARENT = 4,
}
